const ReferFriendModule = {
  namespaced: true,
  state: {
    friendState: true,
    showReferFriend: false
  },
  actions: {
    async checkReferFriend ({ dispatch, commit, state }, { friendMsisdn }) {
      if (friendMsisdn !== '') {
        return dispatch('friendNotification/checkReferFriend', {
          existingCustomerMsisdn: friendMsisdn,
          processName: 'order'
        }, { root: true }).then((response) => {
          if (response.success) {
            commit('storeFriendState', true)
            commit('storeShowReferFriend', true)
          } else {
            commit('storeFriendState', false)
            commit('addError', response, { root: true })
          }
        })
      } else {
        commit('storeFriendState', true)
        commit('storeShowReferFriend', false)
        commit('friendNotification/existingCustomerMsisdn', friendMsisdn, { root: true })
      }
    }
  },
  mutations: {
    storeFriendState (state, friendState) {
      state.friendState = friendState
    },
    storeShowReferFriend (state, showReferFriend) {
      state.showReferFriend = showReferFriend
    }
  },
  getters: {
    friendState: state => state.friendState,
    showReferFriend: state => state.showReferFriend
  }
}

export default ReferFriendModule
